export default __webpack_public_path__ + "static/media/logout.0e20d008.svg";